import './ShareButton.less';
import React, {useState, useEffect} from 'react';
import Icon from "../../../../bootstrap/components/icon/Icon";
import Popup from "../../../../bootstrap/components/popup/Popup";
import __ from "../../../i18n";
import ShareDialog from "../share-dialog/ShareDialog";


export default function ShareButton({course}) {

    const [shareDialogShown, setShareDialogShown] = useState(false);

    return <>
        <button
            className="share-button"
            type="button"
            onClick={() => setShareDialogShown(true)}
            aria-label={__('Share this course with your friends')}
        >
            <Icon name="share"/>
        </button>
        {
            shareDialogShown &&
            <Popup
                name="course-app"
                title={__('Share this course')}
                close={() => setShareDialogShown(false)}
            >
                <ShareDialog course={course}/>
            </Popup>
        }
    </>;
}
